import authInstance from "../Interceptor";

export const AddBrandEffect = (brandData, config) => {
  return authInstance.post("/brands/add", brandData, config);
};

export const EditBrandEffect = (brandId, updatedData) => {
  return authInstance.put(`/brands/update/${brandId}`, updatedData);
};

export const DeleteBrandEffect = (brandId) => {
  return authInstance.delete(`/brands/delete/${brandId}`);
};

export const ViewBrandEffect = (brandId) => {
  return authInstance.get(`/brands/detail?id=${brandId}`);
};

export const ViewAllBrandsEffect = (payload) => {
  return authInstance.get(
    `/brands/list?pagination_required=true&pagesize=10&pageNo=${payload.pageNo}&search_key=${payload.search_key}`
  );
};

export const ViewBrandsByAlcoholIdEffect = (alcoholId) => {
  return authInstance.get(
    `/brands/getBrandbyAlcoholId?type_of_alcohol_id=${alcoholId}`
  );
};

export const ViewAllSearchBrands = () => {
  return authInstance.get(`/brands/list`);
};
